import ApiService from '@/api';
import { AdapterService, ListenTaskInfo } from '.';
import WsResponseModelT from '@/api/Main/dataSource/api/schema-builder/server/models/WsResponseModelT';
import UpdateStatusResponseEvent from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/event/UpdateStatusResponseEvent';

export default class ListenTaskInfoAdapter {
  api: ApiService;
  listenFn: ListenTaskInfo;
  private boundHandlers: Map<string, (...args: any[]) => void> = new Map();

  constructor(value: ListenTaskInfo = null, private currentTaskId?: number) {
    this.api = new ApiService();
    this.listenFn = new ListenTaskInfo(value);
    this.ListenAll();
  }

  ListenAll() {
    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnUpdateTaskStatusEventEvent,
      this.listenFn?.UpdateTaskStatusFn,
      'OnUpdateTaskStatusEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnUpdateTaskPriorityEventEvent,
      this.listenFn?.UpdateTaskPriorityFn,
      'OnUpdateTaskPriorityEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnUpdateTaskDateEndEventEvent,
      this.listenFn?.UpdateTaskDateEndFn,
      'OnUpdateTaskDateEndEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnUpdateTaskDifficultyEventEvent,
      this.listenFn?.UpdateTaskDifficultyFn,
      'OnUpdateTaskDifficultyEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnUpdateTaskFileNameEventEvent,
      this.listenFn?.UpdateTaskFileNameFn,
      'OnUpdateTaskFileNameEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnUpdateTaskNameEventEvent,
      this.listenFn?.UpdateTaskNameFn,
      'OnUpdateTaskNameEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnUpdateTaskDescriptionEventEvent,
      this.listenFn?.UpdateTaskDescriptionFn,
      'OnUpdateTaskDescriptionEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnUpdateTagsInTaskEventEvent,
      this.listenFn?.UpdateTagsInTaskFn,
      'OnUpdateTagsInTaskEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnUpdateTaskObserverEventEvent,
      this.listenFn?.UpdateTaskObserverFn,
      'OnUpdateTaskObserverEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnUpdateTaskPerformersEventEvent,
      this.listenFn?.UpdateTaskPerformersFn,
      'OnUpdateTaskPerformersEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnUpdateTaskSprintEventEvent,
      this.listenFn?.UpdateTaskSprintFn,
      'OnUpdateTaskSprintEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnUpdateTaskTypeEventEvent,
      this.listenFn?.UpdateTaskTypeFn,
      'OnUpdateTaskTypeEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnRemoveTaskSubtaskEventEvent,
      this.listenFn?.RemoveTaskSubtaskFn,
      'OnRemoveTaskSubtaskEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnAttachTaskForParentSubtaskEventEvent,
      this.listenFn?.AttachTaskForParentSubtaskFn,
      'OnAttachTaskForParentSubtaskEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnAddTaskQueueRelationEventEvent,
      this.listenFn?.AddTaskQueueRelationFn,
      'OnAddTaskQueueRelationEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnRemoveTaskQueueRelationEventEvent,
      this.listenFn?.RemoveTaskQueueRelationFn,
      'OnRemoveTaskQueueRelationEventEvent',
    );

    this.subscribe(
      this.api.Main.ProjectTaskSaveService.OnRemoveTaskFilesEventEvent,
      this.listenFn?.RemoveTaskFilesEventFn,
      'OnRemoveTaskFilesEventEvent',
    );
  }

  UnListenAll() {
    this.boundHandlers.forEach((handler, key) => {
      const event = this.getEventByName(key);
      if (event && handler) event.removeListener(handler);
    });
    this.boundHandlers.clear();
  }

  private subscribe(eventEmitter: any, fn: Function | undefined, key: string) {
    if (!fn) return;

    const bound = (data: any) => {
      if (this.currentTaskId && data?.Value?.TaskId !== this.currentTaskId) {
        return;
      }
      fn(data);
    };
    this.boundHandlers.set(key, bound);
    try {
      eventEmitter.on(bound);
    } catch (e) {
      console.error(`Failed to subscribe to ${key}:`, e);
    }
  }

  private getEventByName(key: string): any {
    return (this.api.Main.ProjectTaskSaveService as any)[key];
  }
}
